import React from 'react';
import { DatabaseIcon, NetworkIcon, TagIcon, FileCodeIcon, ShieldCheckIcon, SparklesIcon, CheckCircleIcon, ActivityIcon, PlayIcon, SettingsIcon } from 'lucide-react';
interface AIConfigOverviewProps {
  userPlan: string;
}
export function AIConfigOverview({
  userPlan
}: AIConfigOverviewProps) {
  const stats = [{
    label: 'Connected Sources',
    value: '3',
    icon: DatabaseIcon,
    color: 'bg-blue-50 text-blue-600',
    status: 'Syncing'
  }, {
    label: 'Last Sync',
    value: '2m ago',
    icon: ActivityIcon,
    color: 'bg-green-50 text-green-600',
    status: 'Healthy'
  }, {
    label: 'Active Schemas',
    value: '6',
    icon: NetworkIcon,
    color: 'bg-purple-50 text-purple-600',
    status: 'Mapped'
  }, {
    label: 'Attribute Coverage',
    value: '94%',
    icon: TagIcon,
    color: 'bg-orange-50 text-orange-600',
    status: 'Good'
  }, {
    label: 'Embedding Size',
    value: '2.4M',
    icon: SparklesIcon,
    color: 'bg-pink-50 text-pink-600',
    status: 'Indexed'
  }, {
    label: 'Prompt Packs',
    value: '8',
    icon: FileCodeIcon,
    color: 'bg-cyan-50 text-cyan-600',
    status: 'Active'
  }, {
    label: 'Guardrail Status',
    value: 'Enabled',
    icon: ShieldCheckIcon,
    color: 'bg-red-50 text-red-600',
    status: 'Protected'
  }, {
    label: 'Last Evaluation',
    value: '92/100',
    icon: CheckCircleIcon,
    color: 'bg-green-50 text-green-600',
    status: 'Excellent'
  }];
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-196">
      {/* Quick Actions */}
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg p-6 text-white" data-id="element-197">
        <h2 className="text-2xl font-bold mb-2" data-id="element-198">AI Configuration Center</h2>
        <p className="text-purple-100 mb-4" data-id="element-199">
          Manage your custom data, schemas, prompts, and AI quality controls
        </p>
        <div className="flex gap-3" data-id="element-200">
          <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-white text-purple-600 rounded-lg hover:bg-purple-50 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-201">
            <SettingsIcon className="w-4 h-4" data-id="element-202" />
            Run Setup Wizard
          </button>
          <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-purple-700 text-white rounded-lg hover:bg-purple-800 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-203">
            <PlayIcon className="w-4 h-4" data-id="element-204" />
            Publish Configuration
          </button>
        </div>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-205">
        {stats.map((stat, index) => {
        const Icon = stat.icon;
        return <div key={index} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-206">
              <div className="flex items-center justify-between mb-4" data-id="element-207">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat.color}`} data-id="element-208">
                  <Icon className="w-5 h-5" data-id="element-209" />
                </div>
                <span className="text-xs font-medium text-gray-600 px-2 py-1 bg-gray-100 rounded-full" data-id="element-210">
                  {stat.status}
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-1" data-id="element-211">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-212">{stat.value}</p>
            </div>;
      })}
      </div>
      {/* Recent Activity */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-213">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-214">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-215">
            Recent Activity
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-216">
          {[{
          action: 'Salesforce sync completed',
          time: '2 minutes ago',
          status: 'success'
        }, {
          action: 'New attribute created: ICP Tier',
          time: '15 minutes ago',
          status: 'info'
        }, {
          action: 'Prompt pack updated: SDR Talk Tracks',
          time: '1 hour ago',
          status: 'info'
        }, {
          action: 'Evaluation completed with score 92/100',
          time: '3 hours ago',
          status: 'success'
        }].map((activity, index) => <div key={index} className="px-6 py-4 flex items-center justify-between" data-id="element-217">
              <div className="flex items-center gap-3" data-id="element-218">
                <div className={`w-2 h-2 rounded-full ${activity.status === 'success' ? 'bg-green-500' : 'bg-blue-500'}`} data-id="element-219" />
                <p className="text-sm text-gray-900" data-id="element-220">{activity.action}</p>
              </div>
              <p className="text-xs text-gray-600" data-id="element-221">{activity.time}</p>
            </div>)}
        </div>
      </div>
    </div>;
}